import React from "react";
import { Calendar, Clock, ShieldCheck } from "lucide-react";
import { getPolicyDateInfo } from "../../utils/policyDates";

const DateCell = ({
  icon: Icon,
  label,
  value,
  compact,
  className = "",
  singleLine = false,
}) => (
  <div
    className={
      compact
        ? `min-w-0 ${className}`
        : `p-3.5 bg-white rounded-xl border border-gray-100 shadow-sm ${className}`
    }
  >
    <div className="flex gap-1.5 items-center mb-1">
      <Icon size={compact ? 12 : 14} className="text-emerald-600" />
      <span
        className={`font-semibold tracking-wide text-gray-500 uppercase ${
          compact ? "text-[10px]" : "text-xs"
        }`}
      >
        {label}
      </span>
    </div>
    <p
      className={`font-bold text-gray-900 ${
        singleLine
          ? compact
            ? "text-[9px] leading-tight whitespace-nowrap truncate md:text-[10px]"
            : "text-[11px] leading-tight whitespace-nowrap truncate md:text-xs"
          : compact
          ? "text-xs"
          : "text-sm"
      }`}
      title={singleLine ? value : undefined}
    >
      {value}
    </p>
  </div>
);

const PolicyDatesInfo = ({ policy, compact = false, className = "" }) => {
  const dates = getPolicyDateInfo(policy);

  if (compact) {
    return (
      <div
        className={`grid grid-cols-1 gap-1.5 p-2 bg-gray-50 rounded-lg border border-gray-100 md:grid-cols-2 md:gap-x-3 md:gap-y-2 md:p-3 md:rounded-xl ${className}`}
      >
        <DateCell
          icon={Calendar}
          label="Purchase date"
          value={dates.purchaseDateLabel}
          compact
          className="max-md:hidden"
        />
        <DateCell
          icon={Clock}
          label="Purchase time"
          value={dates.purchaseTimeLabel}
          compact
          className="max-md:hidden"
        />
        <DateCell
          icon={Calendar}
          label="Policy start"
          value={dates.startDateLabel}
          compact
        />
        <DateCell
          icon={ShieldCheck}
          label="Validity"
          value={dates.validityLabel}
          compact
          singleLine
          className="md:col-span-2"
        />
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 gap-3 sm:grid-cols-2 ${className}`}>
      <DateCell
        icon={Calendar}
        label="Purchase date"
        value={dates.purchaseDateLabel}
      />
      <DateCell
        icon={Clock}
        label="Purchase time"
        value={dates.purchaseTimeLabel}
      />
      <DateCell
        icon={Calendar}
        label="Policy start date"
        value={dates.startDateLabel}
      />
      <DateCell
        icon={ShieldCheck}
        label="Policy expiry / validity"
        value={dates.validityLabel}
        singleLine
      />
    </div>
  );
};

export default PolicyDatesInfo;
